// La tabla notas_d2l solo existe en la BD de CEDESCA: no hay selector de sede en
// esta pantalla y siempre se consulta contra esta sede.
export const NOTAS_D2L_HEADQUARTER = 'CEDESCA';

export {
  SIN_VALOR,
  formatearNumero,
  formatearPuntos,
  nombreAlumno,
  nombreEvaluador,
  tieneComentario,
} from './helpers';
